import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=66d71a21"
import script from "./Tips.vue?vue&type=script&lang=ts"
export * from "./Tips.vue?vue&type=script&lang=ts"
import style0 from "./Tips.vue?vue&type=style&index=0&id=66d71a21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports